require('./builders/notification_settings_builder.ts');
require('./builders/preference_builder.ts');
require('./commands/load_contact_info_command.ts');
require('./commands/load_notification_settings_command.ts');
require('./commands/update_all_notification_settings_command.ts');
require('./commands/update_confirmation_number_command.ts');
require('./commands/update_notification_settings_command.ts');
require('./commands/update_phone_number_command.ts');
require('./components/email_contact_details/email_contact_details_controller.ts');
require('./components/notification_settings_checklist/notification_settings_checklist_controller.ts');
require('./components/notification_settings_details_controller.ts');
require('./components/phone_contact_details/phone_contact_details_controller.ts');
require('./config/notification_settings_configuration.es.js');
require('./constants/notification_setting.ts');
require('./constants/notification_settings_dtds.ts');
require('./modals/contact_channel_explaination.ts');
require('./modals/edit_phone_number.ts');
require('./models/contact_information_model.ts');
require('./models/notification_settings_model.ts');
require('./notification_settings_interfacaes.ts');
require('./services/confirmation_number_service.ts');
require('./services/contact_channel_explanation_service.ts');
require('./services/edit_phone_number_service.ts');
require('./services/notify_user_service.ts');
require('./services/phone_number_service.ts');
require('./types/notification_setings_enum.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/core.ts